import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext, useRouter } from '@nuxtjs/composition-api';
import WarRoomAchievement from '@/components/partials/war-room/WarRoomAchievement.vue';
import Avatar from '@/components/common/Avatar/Avatar.vue';
import { achievementSizes } from '@/components/partials/war-room/constants';
import { initials as initialsUtil } from '@/components/utils/core/string';
import type { IPostUser } from '@/types/community';

type WarRoomCommentAuthorProps = {
  author?: IPostUser;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'WarRoomCommentAuthor',
  props: {
    author: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { author: IPostUser };



const router = useRouter();
const { $auth } = useContext();

const achievementSize = achievementSizes.SMALL;

const profileUrl = computed(() => {
  if (!props.author) {
    return;
  }
  if (props.author.username) {
    return `/war-room/profile/${props.author.username}`;
  }
  if (props.author.portfolio_configuration?.is_public || props.author.slug === $auth.user?.slug) {
    return `/p/${props.author.slug}`;
  }
});

const username = computed(() => {
  if (!props.author) {
    return 'Deactivated User';
  }
  if (!profileUrl.value && Boolean(props.author)) {
    return `${props.author.firstname} ${props.author.lastname?.substring(0, 1)}`;
  }
  return props.author.username ?? `${props.author.firstname} ${props.author.lastname}`;
});
const initials = computed(() => initialsUtil(username.value));
const disabledLinkHint = computed(() => {
  if (!props.author) {
    return;
  }
  if (props.author.firstname) {
    return `${props.author.firstname.trim()}'s profile is not public`;
  }

  return `Author's profile is not public`;
});

const position = computed(() => {
  if (!props.author?.position) return '';

  let position = props.author.position;

  if (props.author.current_company) {
    position += ` at ${props.author.current_company}`;
  }

  return position;
});

const achievement = computed(() => {
  if (props.author?.achievements?.length) return props.author.achievements[0];
});

const additionalAchievement = computed(() => {
  const remainingCount = Math.max(0, props.author?.achievements?.length - 1);
  if (remainingCount < 1) return undefined;
  return {
    title: `+${remainingCount}`,
    slug: '',
    level: 'no_level',
  };
});

/**
 * Profile opens by js and not a regular link on purpose.
 * For SEO number of outgoing links should be limited, because page shares link juice between them.
 * We block profile from indexing, so don't need to have a link here.
 * If we need to index profiles, please add a link here.
 */
function handleClick() {
  if (profileUrl.value) router.push(profileUrl.value);
}

return { __sfc: true,props, router, $auth, achievementSize, profileUrl, username, initials, disabledLinkHint, position, achievement, additionalAchievement, handleClick, WarRoomAchievement, Avatar }
}

})